/* NODGRID — スクロールで現れる演出だけを担当する小さなスクリプト。
   CSS 側の .ng-reveal / .is-in と対で動く。

   方針：
   - 1要素につき1回だけ動かす（往復させると読みづらい）
   - ヘッダー・フッター・ヒーローは対象外（ヒーローは読み込み時アニメがある）
   - 動きを減らす設定の人には何もしない
   - IntersectionObserver が無い環境では、単に全部表示する

   2026-07-31 バグ修正（shopの商品がスクロールするまで出ない）
     原因：threshold: 0.05 は「要素の面積の5%が画面内に入ること」を要求する。
           商品一覧（main-collection）は1セクションで画面の何倍も高いため、
           読み込み直後に見えている数百pxでは5%に届かず observer が発火せず、
           セクション全体が opacity:0 のまま取り残されていた。
           スクロールして5%を超えた瞬間に初めて出るので「スクロールするまで出ない」
           という症状になる。画面の高さで条件が変わるため再現性が不安定だった。
     対処：① threshold を 0 にして「1pxでも入ったら出す」に変更
           ② すでに画面内にある要素は observer を待たず即表示（catchUp）
           ③ 保険として一定時間後に必ず全部表示（何があっても白紙にしない）
   ※ 元のファイルは 07_ホームページ\テーマ修正_2026-07-31\backup\ に保存済み */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FAILSAFE = 3000; // ms。これを過ぎたら理由を問わず全部出す

  function targets() {
    var main = document.getElementById('MainContent');
    if (!main) return [];
    var sections = Array.prototype.slice.call(
      main.querySelectorAll('.shopify-section')
    );
    // 最初のセクション（ヒーロー）は読み込み時アニメに任せる
    return sections.slice(1);
  }

  function show(el) {
    el.classList.add('is-in');
  }

  function init() {
    var els = targets();
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          show(e.target);
          io.unobserve(e.target);
        });
      },
      // threshold: 0 ＝ 面積比を問わない。背の高いセクションでも必ず発火する
      { rootMargin: '0px 0px -5% 0px', threshold: 0 }
    );

    els.forEach(function (el) {
      el.classList.add('ng-reveal');
      io.observe(el);
    });

    // すでに画面内にあるものは observer を待たずに出す（読み込み直後の空白を防ぐ）
    function catchUp() {
      var vh = window.innerHeight || 0;
      els.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) {
          show(el);
          io.unobserve(el);
        }
      });
    }
    catchUp();
    // 画像の読み込みでレイアウトが動いた後にもう一度拾う
    window.setTimeout(catchUp, 300);

    // 保険：何が詰まっても隠れたままにはしない
    window.setTimeout(function () {
      els.forEach(show);
    }, FAILSAFE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションを編集した直後にも掛け直す
  document.addEventListener('shopify:section:load', function (e) {
    if (!REDUCED && e.target && e.target.classList) {
      e.target.classList.add('ng-reveal', 'is-in');
    }
  });
})();
